import ky from 'ky';
import { z } from 'zod';
import { ENV } from 'src/utils/env';
import { getHeadersWithBearerToken } from 'src/utils/get-auth-with-bearer';

const CLEAR_CACHE_SCHEMA = z.object({
  devices: z.array(z.string()),
  start_time: z.string(),
  end_time: z.string(),
});

export type ClearCacheSchema = z.infer<typeof CLEAR_CACHE_SCHEMA>;

const CLEAR_CACHE_RESPONSE_SCHEMA = z.object({
  success: z.boolean(),
});

export const clearCachePromise = async (params: ClearCacheSchema) => {
  try {
    const headers = getHeadersWithBearerToken();
    headers.append('Content-Type', 'application/json');

    const parsedParams = CLEAR_CACHE_SCHEMA.safeParse(params);

    if (!parsedParams.success) {
      console.error(parsedParams.error);
      return false;
    }

    const response = await ky
      .post(`${ENV.API_URL}/api/clear_cache/`, {
        body: JSON.stringify({
          ...params,
          devices: parsedParams.data.devices,
        }),
        headers,
      })
      .json();

    const parsedResponse = CLEAR_CACHE_RESPONSE_SCHEMA.safeParse(response);

    if (!parsedResponse) {
      console.error(response);
      return false;
    }

    return parsedResponse;
  } catch (error) {
    console.error('Error clearing cache:', error);
    return false;
  }
};
